


<!-- Questionaire -->
<div class="m-t-20 m-b-60">

  <h3>Table without scroll-fix</h3>
  <nz-table class="table-quest">
    <thead>
    <tr>
      <th class="main" nzLeft="0px">Question</th>
      <th>
        <div class="quest-person">
          <div class="f-l m-r-10 m-t-5">
            <nz-avatar style="color:#f56a00; background-color:#fde3cf;" [nzSrc] = "'https://randomuser.me/api/portraits/men/40.jpg'" nzSize="small" nzIcon="anticon anticon-user"></nz-avatar>
          </div>
          <strong>Primary Insured</strong>
          <span>Mr. Joe Torres</span>
        </div>
      </th>
      <th>
        <div class="quest-person">
          <div class="f-l m-r-10 m-t-5">
            <nz-avatar style="color:#f56a00; background-color:#fde3cf;" nzSize="small" nzIcon="anticon anticon-user" ></nz-avatar>
          </div>
          <strong>Insured</strong>
          <span>Ms. Rachel Torres</span>
        </div>
      </th>
      <th>
        <div class="quest-person">
          <div class="f-l m-r-10 m-t-5">
            <nz-avatar style="color:#f56a00; background-color:#fde3cf;" nzSize="small" nzIcon="anticon anticon-user" ></nz-avatar>
          </div>
          <strong>Insured</strong>
          <span>Mr. Joel Torres</span>
        </div>
      </th>
    </tr>
    </thead>
    <tbody>

    <tr>
      <td nzLeft="0px" class="main">Do you smoke?</td>
      <td>
        <label nz-checkbox nzValue="A" name="isSmoker" [ngModel]="isTrue">Yes</label>
      </td>
      <td>
        <label nz-checkbox nzValue="A" [ngModel]="true">Yes</label>
      </td>
      <td>
        <label nz-checkbox nzValue="A" [ngModel]="isTrue">Yes</label>
      </td>
    </tr>
    <tr>
      <td nzLeft="0px" class="main">What is your height? </td>
      <td>
        <input nz-input placeholder="in cms" class="quest-input-width"/> cms
      </td>
      <td>
        <input nz-input placeholder="in cms" class="quest-input-width"/> cms
      </td>
      <td>
        <input nz-input placeholder="in cms" class="quest-input-width"/> cms
      </td>
    </tr>
    <tr>
      <td nzLeft="0px" class="main">Have you ever had child-birth related disorders? </td>
      <td>
        <span class="disabled">N/A</span>
      </td>
      <td>
        <label nz-checkbox nzValue="A" [ngModel]="true">Yes</label>
        <nz-select nzShowSearch  class="quest-input-width d-b" nzAllowClear nzPlaceHolder="Choose">
          <nz-option nzValue="jack" nzLabel="Ectopic "></nz-option>
          <nz-option nzValue="lucy" nzLabel="Pre-term labor"></nz-option>
        </nz-select>
      </td>
      <td>
        <span class="disabled">N/A</span>
      </td>
    </tr>
    <tr>
      <td nzLeft="0px" class="main">Have you ever had any of the following conditions?</td>
      <td>
        <!-- Leave blank -->
      </td>
      <td>
        <!-- Leave blank -->
      </td>
      <td>
        <!-- Leave blank -->
      </td>
    </tr>
    <tr>
      <td nzLeft="0px" class="sub">
        a. Stroke, transient ischaemic attack (TIA), brain haemorrhage, brain aneurysm or other brain related injuries?
      </td>
      <td>
        <label nz-checkbox nzValue="A" [ngModel]="true">Yes</label>
      </td>
      <td>
        <label nz-checkbox nzValue="A" [ngModel]="true">Yes</label>
      </td>
      <td>
        <label nz-checkbox nzValue="A" [ngModel]="true">Yes</label>
      </td>
    </tr>

    <tr>
      <td nzLeft="0px" class="sub">
        b. Chest Pain, Angio, heart attack, heart enlargement, heart failure or any other heart conditon?
      </td>
      <td>
        <label nz-checkbox nzValue="A" [ngModel]="true">Yes</label>
        <input nz-input placeholder="What was it?" name="alc1" class="quest-input-width d-b"/>
      </td>
      <td>
        <label nz-checkbox nzValue="A" name="heart1" [ngModel]="isTrue">Yes</label>
        <input nz-input placeholder="What was it?" name="alc1" class="quest-input-width d-b" value="Chest Pain"/>
      </td>
      <td>
        <label nz-checkbox nzValue="A" [ngModel]="true">Yes</label>
        <input nz-input placeholder="What was it?" name="alc1" class="quest-input-width d-b"/>
      </td>
    </tr>

    <tr>
      <td nzLeft="0px" class="sub">
        c. Peripheral vascular or any disease or disorder of the aorta or arteries?
      </td>
      <td>
        <label nz-checkbox nzValue="A" [ngModel]="true">Yes</label>
      </td>
      <td>
        <label nz-checkbox nzValue="A" [ngModel]="true">Yes</label>
      </td>
      <td>
        <label nz-checkbox nzValue="A" [ngModel]="true">Yes</label>
      </td>
    </tr>

    <tr>
      <td nzLeft="0px" class="sub">
        d. Asthama, bronchitis, pneumonia, tuberculosis, emphysems or any other breating / lung disorder?
      </td>
      <td>
        <label nz-checkbox nzValue="A" [ngModel]="true">Yes</label>
      </td>
      <td>
        <label nz-checkbox nzValue="A" [ngModel]="true">Yes</label>
      </td>
      <td>
        <label nz-checkbox nzValue="A" [ngModel]="true">Yes</label>
      </td>
    </tr>

    <tr>
      <td nzLeft="0px" class="main">
        Are you currently serving in the Armed Forces, or planning to in the future?
      </td>
      <td>
        <label nz-checkbox nzValue="A" [ngModel]="true">Yes</label>
      </td>
      <td>
        <label nz-checkbox nzValue="A" [ngModel]="true">Yes</label>
      </td>
      <td>
        <label nz-checkbox nzValue="A" [ngModel]="true">Yes</label>
      </td>
    </tr>

    </tbody>
  </nz-table>



  <!-- Primary Save -->
  <div class="card-summary-data-footer data-footer-primary">
    <div>
      <button nz-button>Cancel</button>
    </div>
    <div>
      <button nz-button class="b-0 m-r-10">Cancel</button>
      <button nz-button [nzType]="'primary'">Save</button>
    </div>
  </div>
  <!-- /Primary Save -->

  <h3 class="m-t-60">Table with scroll-fix</h3>
  <nz-table class="table-quest" [nzScroll]="{ x:'960px',y: '400px' }">
    <thead>
    <tr>
      <th class="main" nzLeft="0px" nzWidth="300px">Question</th>
      <th>
        <div class="quest-person">
          <div class="f-l m-r-10 m-t-5">
            <nz-avatar style="color:#f56a00; background-color:#fde3cf;" [nzSrc] = "'https://randomuser.me/api/portraits/men/40.jpg'" nzSize="small" nzIcon="anticon anticon-user"></nz-avatar>
          </div>
          <strong>Primary Insured</strong>
          <span>Mr. Joe Torres</span>
        </div>
      </th>
      <th>
        <div class="quest-person">
          <div class="f-l m-r-10 m-t-5">
            <nz-avatar style="color:#f56a00; background-color:#fde3cf;" nzSize="small" nzIcon="anticon anticon-user" ></nz-avatar>
          </div>
          <strong>Insured</strong>
          <span>Ms. Rachel Torres</span>
        </div>
      </th>
      <th>
        <div class="quest-person">
          <div class="f-l m-r-10 m-t-5">
            <nz-avatar style="color:#f56a00; background-color:#fde3cf;" nzSize="small" nzIcon="anticon anticon-user" ></nz-avatar>
          </div>
          <strong>Insured</strong>
          <span>Mr. Joel Torres</span>
        </div>
      </th>
      <th>
        <div class="quest-person">
          <div class="f-l m-r-10 m-t-5">
            <nz-avatar style="color:#f56a00; background-color:#fde3cf;" nzSize="small" nzIcon="anticon anticon-user" ></nz-avatar>
          </div>
          <strong>Insured</strong>
          <span>Mr. Joel Torres</span>
        </div>
      </th>
      <th>
        <div class="quest-person">
          <div class="f-l m-r-10 m-t-5">
            <nz-avatar style="color:#f56a00; background-color:#fde3cf;" nzSize="small" nzIcon="anticon anticon-user" ></nz-avatar>
          </div>
          <strong>Insured</strong>
          <span>Mr. Joel Torres</span>
        </div>
      </th>
    </tr>
    </thead>
    <tbody>

    <tr>
      <td nzLeft="0px" nzWidth="300px" class="main">Do you smoke?</td>
      <td>
        <label nz-checkbox nzValue="A" name="isSmoker" [ngModel]="isTrue">Yes</label>
      </td>
      <td>
        <label nz-checkbox nzValue="A" [ngModel]="true">Yes</label>
      </td>
      <td>
        <label nz-checkbox nzValue="A" [ngModel]="isTrue">Yes</label>
      </td>
      <td>
        <label nz-checkbox nzValue="A" [ngModel]="isTrue">Yes</label>
      </td>
      <td>
        <label nz-checkbox nzValue="A" [ngModel]="isTrue">Yes</label>
      </td>
    </tr>
    <tr>
      <td nzLeft="0px" nzWidth="300px" class="main">What is your height? </td>
      <td>
        <input nz-input placeholder="in cms" class="quest-input-width"/> cms
      </td>
      <td>
        <input nz-input placeholder="in cms" class="quest-input-width"/> cms
      </td>
      <td>
        <input nz-input placeholder="in cms" class="quest-input-width"/> cms
      </td>
      <td>
        <input nz-input placeholder="in cms" class="quest-input-width"/> cms
      </td>
      <td>
        <input nz-input placeholder="in cms" class="quest-input-width"/> cms
      </td>
    </tr>
    <tr>
      <td nzLeft="0px" nzWidth="300px" class="main">Have you ever had child-birth related disorders? </td>
      <td>
        <span class="disabled">N/A</span>
      </td>
      <td>
        <label nz-checkbox nzValue="A" [ngModel]="true">Yes</label>
        <nz-select nzShowSearch  class="quest-input-width d-b" nzAllowClear nzPlaceHolder="Choose">
          <nz-option nzValue="jack" nzLabel="Ectopic "></nz-option>
          <nz-option nzValue="lucy" nzLabel="Pre-term labor"></nz-option>
        </nz-select>
      </td>
      <td>
        <span class="disabled">N/A</span>
      </td>
      <td>
        <span class="disabled">N/A</span>
      </td>
      <td>
        <span class="disabled">N/A</span>
      </td>
    </tr>
    <tr>
      <td nzLeft="0px" nzWidth="300px" class="main">Have you ever had any of the following conditions?</td>
      <td>
        <!-- Leave blank -->
      </td>
      <td>
        <!-- Leave blank -->
      </td>
      <td>
        <!-- Leave blank -->
      </td>
      <td>
        <!-- Leave blank -->
      </td>
      <td>
        <!-- Leave blank -->
      </td>
    </tr>
    <tr>
      <td nzLeft="0px" nzWidth="300px" class="sub">
        a. Stroke, transient ischaemic attack (TIA), brain haemorrhage, brain aneurysm or other brain related injuries?
      </td>
      <td>
        <label nz-checkbox nzValue="A" [ngModel]="true">Yes</label>
      </td>
      <td>
        <label nz-checkbox nzValue="A" [ngModel]="true">Yes</label>
      </td>
      <td>
        <label nz-checkbox nzValue="A" [ngModel]="true">Yes</label>
      </td>
      <td>
        <label nz-checkbox nzValue="A" [ngModel]="true">Yes</label>
      </td>
      <td>
        <label nz-checkbox nzValue="A" [ngModel]="true">Yes</label>
      </td>
    </tr>

    <tr>
      <td nzLeft="0px" nzWidth="300px" class="sub">
        b. Chest Pain, Angio, heart attack, heart enlargement, heart failure or any other heart conditon?
      </td>
      <td>
        <label nz-checkbox nzValue="A" [ngModel]="true">Yes</label>
        <input nz-input placeholder="What was it?" name="alc1" class="quest-input-width d-b"/>
      </td>
      <td>
        <label nz-checkbox nzValue="A" name="heart1" [ngModel]="isTrue">Yes</label>
        <input nz-input placeholder="What was it?" name="alc1" class="quest-input-width d-b" value="Chest Pain"/>
      </td>
      <td>
        <label nz-checkbox nzValue="A" [ngModel]="true">Yes</label>
        <input nz-input placeholder="What was it?" name="alc1" class="quest-input-width d-b"/>
      </td>
      <td>
        <label nz-checkbox nzValue="A" [ngModel]="true">Yes</label>
        <input nz-input placeholder="What was it?" name="alc1" class="quest-input-width d-b"/>
      </td>
      <td>
        <label nz-checkbox nzValue="A" [ngModel]="true">Yes</label>
        <input nz-input placeholder="What was it?" name="alc1" class="quest-input-width d-b"/>
      </td>
    </tr>

    <tr>
      <td nzLeft="0px" nzWidth="300px" class="sub">
        c. Peripheral vascular or any disease or disorder of the aorta or arteries?
      </td>
      <td>
        <label nz-checkbox nzValue="A" [ngModel]="true">Yes</label>
      </td>
      <td>
        <label nz-checkbox nzValue="A" [ngModel]="true">Yes</label>
      </td>
      <td>
        <label nz-checkbox nzValue="A" [ngModel]="true">Yes</label>
      </td>
      <td>
        <label nz-checkbox nzValue="A" [ngModel]="true">Yes</label>
      </td>
      <td>
        <label nz-checkbox nzValue="A" [ngModel]="true">Yes</label>
      </td>
    </tr>

    <tr>
      <td nzLeft="0px" nzWidth="300px" class="sub">
        d. Asthama, bronchitis, pneumonia, tuberculosis, emphysems or any other breating / lung disorder?
      </td>
      <td>
        <label nz-checkbox nzValue="A" [ngModel]="true">Yes</label>
      </td>
      <td>
        <label nz-checkbox nzValue="A" [ngModel]="true">Yes</label>
      </td>
      <td>
        <label nz-checkbox nzValue="A" [ngModel]="true">Yes</label>
      </td>
      <td>
        <label nz-checkbox nzValue="A" [ngModel]="true">Yes</label>
      </td>
      <td>
        <label nz-checkbox nzValue="A" [ngModel]="true">Yes</label>
      </td>
    </tr>

    <tr>
      <td nzLeft="0px" nzWidth="300px" class="main">
        Are you currently serving in the Armed Forces, or planning to in the future?
      </td>
      <td>
        <label nz-checkbox nzValue="A" [ngModel]="true">Yes</label>
      </td>
      <td>
        <label nz-checkbox nzValue="A" [ngModel]="true">Yes</label>
      </td>
      <td>
        <label nz-checkbox nzValue="A" [ngModel]="true">Yes</label>
      </td>
      <td>
        <label nz-checkbox nzValue="A" [ngModel]="true">Yes</label>
      </td>
      <td>
        <label nz-checkbox nzValue="A" [ngModel]="true">Yes</label>
      </td>
    </tr>

    </tbody>

  </nz-table>

</div>
        
